<template>
  <div role="alert" class="bg-amber-400 px-4 py-2 text-center text-sm font-medium text-amber-950">
    Otago is winding down and no longer accepting new sign-ups. Existing accounts remain accessible for now.
  </div>
</template>
